<template>
  <div>
    <div style="text-align:left;">
      <el-button type="primary" size="small" @click="onOk">
        选择
      </el-button>
    </div>
    <bsp-table
      :data.sync="list"
      auto-resize
      height="500px"
      ref="accountTable"
      @select-change="selectChange"
      @select-all="selectAll"
      :ciic-data-filter.sync="listQuery"
      :showPagination="listQuery.page"
      @ciic-data-refresh="_getListpage"
      show-footer
      fixed="left"
    >
      <vxe-table-column
        type="selection"
        width="60"
        fixed="left"
      />
      <vxe-table-column
        fixed="left"
        type="index"
        title="序号"
        width="60"
      />

      <bsp-table-column
        field="id"
        filter-type="input"
        :showPagination="false"
        :visible="false"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field="A0010002"
        title="姓名"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.empName }}</span>
        </template>
      </bsp-table-column>
      <bsp-table-column
        field="deptName"
        title="所属机构"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.deptName }}</span>
        </template>
      </bsp-table-column>

      <bsp-table-column
        field="A0010005"
        title="证件号码"
        filter-type="input"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.idCard }}</span>
        </template>
      </bsp-table-column>

    </bsp-table>
  </div>
</template>

<script>
  import defaultInvoice from "@/components/bsp/bsp-dicts-invoice/default";
  import bspTable from "@/components/bsp/bsp-table/bsp-table";
  import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
  import { queryPersonListPage } from  "@/api/wage/payGroup";
  import { getEmpListOfSelect } from  "@/api/emp/emp";
  import { mapGetters } from 'vuex';
  export default {
    name: "Table",
    components: { bspTableColumn, bspTable, defaultInvoice},
    props:{
      cusId: {
          type: String,
          default: '',
      },
      perDatas: {
        type: Array,
        default: () => (
          []
        )
      },
      outPerDatas: {
        type: Array,
        default: () => (
          []
        )
      },
      orgDatas: {
        type: Array,
        default: () => (
          []
        )
      },
      state: {
        type: String,
        default: '',
      },
    },
    created(){
      console.log("打开人员页面");
      this._getListpage();

    },
    mounted() {

    },
    computed: {
      ...mapGetters([
        'dicts',
        'pms'
      ]),
    },
    data(){
      return{
        dialogheaderVisible:false,
        orgIds:[],
        list: [],
        perList:[],
        multipleSelection: [],
        listQuery:{
          limit: 20,
          page: 1,
          total: 0,
          orgMap:{},
          orgList:[],
          perDatas:[],
          outPerDatas:[],
          orgDatas:[],
          state:"",
          cusId: this.cusId
        },
      }
    },
    methods: {

      //复选框全选事件
      selectAll({checked, selection}){
        this.multipleSelection = selection;
        console.log("全选-----",JSON.stringify(this.multipleSelection))
      },


      //获取列表数据
      _getListpage(e){
        if(e!=undefined){
          this.listQuery.orgList = e;
        }
        this.listQuery.perDatas = this.perDatas;
        this.listQuery.outPerDatas = this.outPerDatas;
        this.listQuery.cusId = this.cusId;
        this.listQuery.state = this.state;
        this.listQuery.orgDatas = this.orgDatas;
        console.log("6-10--getEmpListOfSelect参数this.listQuery=",this.listQuery);
        getEmpListOfSelect(this.listQuery).then(res => {
          console.log("获取人员数据6-10-res---",res);
          this.listQuery.total = res.data.total;
          this.list = res.data.records;
        })
      },

      //批量更改状态
      selectChange({checked, row}){
        console.log('check')
        if(checked){
          this.multipleSelection.push(row)
        }
        if(!checked){
          this.multipleSelection.filter((item,index) => {
            if(item===row){
              this.multipleSelection.splice(index,1)
            }
          })
        }

      },

      onOk(){
        let listSize=this.multipleSelection.length;
        if(listSize==0){
          this.$message.error('请选择至少选中一行')
        }else{
          this.dialogheaderVisible = false;
          let obj = {dialog:this.dialogheaderVisible,data:this.multipleSelection}
          console.log("确定事件---:",obj);
          this.$emit('personDatas',obj);
        }
      },
    },

  }
</script>

<style scoped>

</style>
